import { UsageStatusReason } from '../types/Instance'

export const getUsageStatusReasonMessage = (
	reason: UsageStatusReason,
	productVersion?: string,
	maxProductVersion?: string
) => {
	switch (reason) {
		case 'stale_renewal': {
			return 'The last instance renewal was more than 90 days ago'
		}
		case 'same_ip_newer': {
			return 'Another active instance on the same IP has a more recent renewal'
		}
		case 'outdated_version': {
			return `
				The current product version ${productVersion ?? ''} is lower than 
				the latest active version ${maxProductVersion ?? ''}
			`
		}
		default:
			return ''
	}
}